import Category from '../Category'
import { CatalogPath, CategoryNeutralPath } from 'navigation/Routes'
import { freeCoursesCategory } from '../store'
import { ProfileTypes } from 'constants/'
import { MediaQuery } from 'UI'

const skeletonCategoriesLength = 6

export default ({
  categories,
  selectedCategory,
  allCoursesCategory,
  goToCatalog,
  addtionalAction,
  loading,
  profileType,
  cleanFreeCoursesTags
}) => {
  const isSubscribed = profileType === ProfileTypes.BasicSubscriber || profileType === ProfileTypes.PremiumSubscriber
  const freeCategoryHandler = !isSubscribed ? freeCoursesCategory : null
  const categoriesToShow = loading
    ? [...Array(skeletonCategoriesLength).fill(true)]
    : [freeCategoryHandler, ...categories].filter(Boolean)

  return (
    <>
      <MediaQuery HideOnDesktop>
        <Category
          loading={loading}
          {...allCoursesCategory}
          active={selectedCategory.Id === allCoursesCategory.Id}
          handleClick={() => {
            cleanFreeCoursesTags()
            goToCatalog(`${CatalogPath}`)
            addtionalAction && addtionalAction()
          }}
          path={`${CatalogPath}`}
        />
      </MediaQuery>
      {
        [...categoriesToShow].map((category, key) =>
          <Category
            loading={loading}
            key={`${key}-${loading}`}
            {...category}
            active={selectedCategory.Id === category.Id}
            handleClick={() => {
              category.Id === freeCategoryHandler?.Id && cleanFreeCoursesTags()
              goToCatalog(`${category.Slug ? `${CategoryNeutralPath}/${category.Slug}` : CatalogPath}`)
              addtionalAction && addtionalAction()
            }}
            path={`${category.Slug ? `${CategoryNeutralPath}/${category.Slug}` : CatalogPath}`}
          />
        )
      }
      <MediaQuery ShowOnDesktop>
        <Category
          loading={loading}
          {...allCoursesCategory}
          active={selectedCategory.Id === allCoursesCategory.Id}
          handleClick={() => {
            cleanFreeCoursesTags()
            goToCatalog(`${CatalogPath}`)
            addtionalAction && addtionalAction()
          }}
          path={`${CatalogPath}`}
          margin='8px 0'
        />
      </MediaQuery>
    </>
  )
}
